// Brand
const Listbrand = () => import('@/views/brand-ambassador')
const Detailbrand = () => import('@/views/brand-ambassador/detail')
const HistoryFollowingCampaign = () => import('@/views/brand-ambassador/history')
const ListPointHistory = () => import('@/views/brand-ambassador/pointHistory/index')
const FormPointHistory = () => import('@/views/brand-ambassador/pointHistory/form')
const ListCoinHistory = () => import('@/views/brand-ambassador/coinHistory/index')
const FormCoinHistory = () => import('@/views/brand-ambassador/coinHistory/form')
export default {
    path: 'brand-ambassador',
    redirect: '/brand-ambassador',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'brand-ambassador',
            component: Listbrand,
            meta: {
                link: 'brand-ambassador',
                breadcrumb: [
                    { title: 'Brand Ambassador', active: true },
                ],
                pageTitle: 'Brand Ambassador'
            },
        },
        {
            path: ':id',
            name: 'detailbrand',
            component: Detailbrand,
            meta: {
                link: 'brand-ambassador',
                breadcrumb: [
                    { title: 'Brand Ambassador', url: '/brand-ambassador' },
                    { title: 'View', active: true }
                ],
                pageTitle: 'View Brand Ambassador'
            },
        },
        {
            path: ':id/history',
            name: 'historybrand',
            component: HistoryFollowingCampaign,
            meta: {
                link: 'brand-ambassador',
                breadcrumb: [
                    { title: 'Brand Ambassador', url: '/brand-ambassador' },
                    { title: 'View', active: true }
                ],
                pageTitle: 'Campaign Followed'
            },
        },
        {
            path: ':userId/point-history',
            name: 'pointhistorybrand',
            component: ListPointHistory,
            meta: {
                link: 'brand-ambassador',
                breadcrumb: [
                    { title: 'Brand Ambassador', url: '/brand-ambassador' },
                    { title: 'View', active: true }
                ],
                pageTitle: 'Point History'
            },
        },
        {
            path: ':userId/point-history/add',
            name: 'addpointhistorybrand',
            component: FormPointHistory,
            meta: {
                link: 'brand-ambassador',
                breadcrumb: [
                    { title: 'Brand Ambassador', url: '/brand-ambassador' },
                    { title: 'View', active: true }
                ],
                pageTitle: 'Add Point History'
            },
        },
        {
            path: ':userId/point-history/edit/:id',
            name: 'editpointhistorybrand',
            component: FormPointHistory,
            meta: {
                link: 'brand-ambassador',
                breadcrumb: [
                    { title: 'Brand Ambassador', url: '/brand-ambassador' },
                    { title: 'View', active: true }
                ],
                pageTitle: 'Edit Point History'
            },
        },
        {
            path: ':userId/coin-history',
            name: 'coinhistorybrand',
            component: ListCoinHistory,
            meta: {
                link: 'brand-ambassador',
                breadcrumb: [
                    { title: 'Brand Ambassador', url: '/brand-ambassador' },
                    { title: 'View', active: true }
                ],
                pageTitle: 'Coin History'
            },
        },
        {
            path: ':userId/coin-history/add',
            name: 'addcoinhistorybrand',
            component: FormCoinHistory,
            meta: {
                link: 'brand-ambassador',
                breadcrumb: [
                    { title: 'Brand Ambassador', url: '/brand-ambassador' },
                    { title: 'View', active: true }
                ],
                pageTitle: 'Add Coin History'
            },
        },
        {
            path: ':userId/coin-history/edit/:id',
            name: 'editcoinhistorybrand',
            component: FormCoinHistory,
            meta: {
                link: 'brand-ambassador',
                breadcrumb: [
                    { title: 'Brand Ambassador', url: '/brand-ambassador' },
                    { title: 'View', active: true }
                ],
                pageTitle: 'Edit Coin History'
            },
        },
    ]
}